<template>
  <v-app>
    <transition name="fade">
      <router-view />
    </transition>
  </v-app>
</template>

<script>
export default {
  name: 'SpitiArt',
  watch: {
    '$route.meta.darkMode': {
      handler(darkMode) {
        this.$vuetify.theme.dark = darkMode;
      },
      deep: true,
    },
  },
};
</script>
